import type { CityConfig } from "../city-template/types";

export const watervilleConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Maine CDC Vital Records", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine vital records office in Augusta" },
    { label: "Marriage Licenses — Kennebec County Clerk", href: "https://www.kennebeccounty.org/", description: "Kennebec County Clerk — marriage license issuance" },
    { label: "Divorce Records — Kennebec County Clerk", href: "https://www.kennebeccounty.org/", description: "Kennebec County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Waterville",
  state: "Maine",
  stateAbbr: "ME",
  slug: "waterville",
  route: "/waterville",
  title: "Emergency Passport Waterville, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Waterville, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Waterville, Winslow, Fairfield, and Oakland travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Waterville, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Waterville and Kennebec County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Waterville%20Maine%20college%20town%20along%20the%20Kennebec%20River%2C%20Colby%20College%20hillside%20backdrop%2C%20charming%20downtown%20with%20historic%20brick%20buildings%20and%20tree-lined%20streets%2C%20New%20England%20autumn%20foliage%2C%20warm%20golden%20afternoon%20light%2C%20professional%20photography%2C%20scenic%20river%20and%20small%20city%20view%2C%20no%20visible%20text%20or%20people&width=1800&height=700&seq=waterville-me-hero-001&orientation=landscape",
  heroImageAlt: "Waterville Maine college town along the Kennebec River with historic downtown",
  geoPosition: "44.5523;-69.6317",
  geoPlacename: "Waterville, Maine",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 190 miles (3.5 hours) from Waterville, ME",
  },
  nearbyCitiesZips: [
    { name: "Downtown Waterville", zips: "04901" },
    { name: "Winslow", zips: "04901" },
    { name: "Fairfield", zips: "04937" },
    { name: "Oakland", zips: "04963" },
    { name: "Sidney", zips: "04330" },
    { name: "Clinton", zips: "04927" },
    { name: "Benton", zips: "04901" },
    { name: "Albion", zips: "04910" },
    { name: "Augusta", zips: "04330" },
    { name: "Skowhegan", zips: "04976" },
    { name: "Farmington", zips: "04938" },
    { name: "Newport", zips: "04953" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Waterville departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Portland", route: "/portland-me" },
    { name: "Emergency passport help in Bangor", route: "/bangor" },
    { name: "Urgent passport services in Augusta", route: "/augusta-me" },
    { name: "Same-day passport help in Lewiston", route: "/lewiston" },
    { name: "Expedited passport services in Biddeford", route: "/biddeford" },
    { name: "Passport courier services in South Portland", route: "/south-portland" },
    { name: "Rush passport help in Auburn", route: "/auburn-me" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Waterville, Maine remotely via secure courier. We do not have a walk-in office in Waterville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Waterville travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving all of central Kennebec County",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Waterville and the surrounding central Maine area. From downtown Waterville near the Kennebec River to the college neighborhood surrounding Colby College — we help Waterville travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Waterville neighborhoods and nearby cities including Winslow, Fairfield, Oakland, Sidney, Clinton, Benton, and Skowhegan. If you are in Kennebec or Somerset County, we have you covered.",
  howItWorksIntro: "Most Waterville travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency. Our emergency and expedited passport process is designed for Maine travelers who need fast, reliable results.",
  mistakesIntro: "Waterville is home to Colby College and many international travelers. Passport delays can derail study abroad programs and family trips. Here are the most common mistakes we see.",
  testimonialsIntro: "Waterville travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Waterville? Here are the most common ones we hear from central Maine travelers.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Waterville international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Michelle R.",
      location: "Waterville, ME",
      rating: 5,
      text: "My Colby College study abroad program started in two weeks and I realized my passport had expired. Fast Passport Center processed my renewal in 48 hours. Shipped from the Waterville UPS Store — incredibly smooth.",
      service: "Emergency Passport",
    },
    {
      name: "Tom A.",
      location: "Winslow, ME",
      rating: 5,
      text: "Needed to renew my passport for a medical conference in Switzerland. Fast Passport Center caught a signature error before submission. Had my passport in 5 days. Great service for central Maine.",
      service: "Passport Renewal",
    },
    {
      name: "Karen L.",
      location: "Fairfield, ME",
      rating: 5,
      text: "Lost my passport a week before my anniversary trip to Italy. Fast Passport Center handled the DS-64 and got me a replacement in 2 days. They saved our trip completely.",
      service: "Lost Passport",
    },
    {
      name: "Brian W.",
      location: "Oakland, ME",
      rating: 5,
      text: "Frequent traveler who uses Fast Passport Center for every renewal. Professional, fast, and always on time. The best passport service available to Waterville-area residents.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "waterville-1",
      name: "Waterville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Elm Plaza",
      city: "Waterville",
      state: "ME",
      zip: "04901",
      phone: "(207) 872-5601",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Waterville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Acceptance hours are limited. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "waterville-2",
      name: "Winslow Town Office",
      type: "Town Office Passport Acceptance",
      address: "114 Benton Ave",
      city: "Winslow",
      state: "ME",
      zip: "04901",
      phone: "(207) 872-2776",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "2 miles from downtown Waterville",
      website: "https://www.winslow-me.gov/",
      websiteLabel: "Winslow Town Office",
      notes: "Convenient for Winslow residents. Call ahead to schedule passport acceptance appointment.",
      icon: "ri-government-line",
    },
    {
      id: "waterville-3",
      name: "Fairfield Town Office",
      type: "Town Office Passport Acceptance",
      address: "19 Lawrence Ave",
      city: "Fairfield",
      state: "ME",
      zip: "04937",
      phone: "(207) 453-7911",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "6 miles from downtown Waterville",
      website: "https://www.fairfieldme.com/",
      websiteLabel: "Fairfield Town Office",
      notes: "Good option for Fairfield and Benton residents. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "waterville-4",
      name: "Oakland Town Office",
      type: "Town Office Passport Acceptance",
      address: "58 Church St",
      city: "Oakland",
      state: "ME",
      zip: "04963",
      phone: "(207) 465-7357",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "7 miles from downtown Waterville",
      website: "https://www.oaklandmaine.us/",
      websiteLabel: "Oakland Town Office",
      notes: "Limited hours — call ahead to confirm passport acceptance availability.",
      icon: "ri-government-line",
    },
    {
      id: "waterville-5",
      name: "Augusta Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40 Western Ave",
      city: "Augusta",
      state: "ME",
      zip: "04330",
      phone: "(207) 622-3139",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "18 miles from downtown Waterville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular backup option for Waterville residents. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "waterville-6",
      name: "Skowhegan Town Office",
      type: "Town Office Passport Acceptance",
      address: "225 Water St",
      city: "Skowhegan",
      state: "ME",
      zip: "04976",
      phone: "(207) 474-6901",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "20 miles from downtown Waterville",
      website: "https://www.skowhegan.org/",
      websiteLabel: "Skowhegan Town Office",
      notes: "Good option for northern Kennebec County residents. Call to schedule.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Maine photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Waterville acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Waterville applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Waterville families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Waterville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Waterville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Waterville address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Waterville, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Waterville in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for Waterville travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Waterville, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Waterville residents.",
    },
    {
      q: "Where can I get a fast passport renewal in Waterville, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Waterville with no office visit required. We serve all Waterville neighborhoods and the surrounding Kennebec County area. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "What is the fastest way to get an urgent passport in Waterville, Maine?",
      a: "The fastest way to get an urgent passport in Waterville is through Fast Passport Center's emergency courier service. Our registered couriers deliver your documents directly to State Department processing facilities, achieving 24–48 hour turnaround. This is significantly faster than standard mail processing or even government expedited mail.",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "Where are the closest passport acceptance facilities in Waterville?",
      a: "Popular options include the Waterville Post Office (04901), Winslow Town Office (04901), Fairfield Town Office (04937), and Oakland Town Office (04963). All require appointments. We help you find the most convenient location and schedule your visit.",
    },
    {
      q: "What if I live in Winslow, Fairfield, or Oakland?",
      a: "We serve all of Kennebec County including Winslow, Fairfield, Oakland, Clinton, Sidney, and Benton. Our overnight shipping labels work from any UPS location, so your exact location within central Maine doesn't affect processing speed.",
    },
    {
      q: "I'm a Colby College student — can you help me get a passport quickly?",
      a: "Absolutely. We regularly help college students who need passports for study abroad programs or spring break trips. If your program or departure is coming up fast, our 24–48 hour emergency service can get you a passport in time. Apply online and ship from the Waterville UPS Store.",
    },
    {
      q: "How much does expedited passport service cost in Waterville?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline and needs.",
    },
    {
      q: "What documents do I need for a first-time passport in Waterville?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Waterville?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Waterville families through the entire process and help schedule acceptance clerk appointments.",
    },
    {
      q: "How far is Waterville from the Boston Passport Agency?",
      a: "Waterville is approximately 190 miles from the Boston Passport Agency — about a 3.5-hour drive. With Fast Passport Center, you avoid that trip entirely. We courier your documents directly to State Department facilities, saving you time and stress.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Waterville", address: "399 Kennedy Memorial Dr, Waterville, ME 04901", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Waterville", address: "10 Concourse, Waterville, ME 04901", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Waterville", address: "1 Elm Plaza, Waterville, ME 04901", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Waterville", address: "25 Elm Plaza, Waterville, ME 04901", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Winslow", address: "114 Benton Ave, Winslow, ME 04901", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Augusta", address: "11 Whitten Rd, Augusta, ME 04330", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Skowhegan", address: "225 Water St, Skowhegan, ME 04976", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Farmington", address: "20 Farmington Falls Rd, Farmington, ME 04938", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "BMV — Waterville",
      address: "1 Elm Plaza, Waterville, ME 04901",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "BMV — Augusta",
      address: "19 Anthony Ave, Augusta, ME 04330",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service center. Online appointment booking available.",
      featured: false,
    },
    {
      name: "BMV — Skowhegan",
      address: "225 Water St, Skowhegan, ME 04976",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "BMV — Farmington",
      address: "20 Farmington Falls Rd, Farmington, ME 04938",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Convenient for western Somerset County residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "75 miles from Waterville (1.5 hours)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport with direct flights to Canada, Florida, and major U.S. hubs. The primary international departure point for Waterville-area travelers.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: true,
    },
    {
      code: "BGR",
      name: "Bangor International Airport",
      distance: "60 miles from Waterville (1 hour)",
      address: "2870 Godfrey Blvd, Bangor, ME 04401",
      note: "Maine's second busiest airport — actually closer than Portland for Waterville travelers. Seasonal international flights and domestic connections.",
      flightUrl: "https://www.flybangor.com/",
      flightLabel: "Bangor Airport",
      featured: true,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "190 miles from Waterville (3.5 hours)",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many central Maine travelers connect through Boston for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan Airport",
      featured: false,
    },
  ],
};